import React, { useState, useEffect } from 'react';
import Icon from './UI/Icon';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${isOpen ? 'menu-open' : ''}`}>
      <div className="container nav-container">
        {/* Brand/Logo Section */}
        <a href="#home" className="nav-logo-badge" onClick={closeMenu}>
          <img 
            src="/assets/logo.png" 
            alt="Active Joint Physiotherapy" 
            className="nav-logo-img" 
          />
        </a>

        {/* Desktop Menu */}
        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <a href="#home" className="nav-item" onClick={closeMenu}>Home</a>
          <a href="#specializations" className="nav-item" onClick={closeMenu}>Specializations</a>
          <a href="#about" className="nav-item" onClick={closeMenu}>About</a>
          <a href="#services" className="nav-item" onClick={closeMenu}>Services</a>
          <a href="#contact" className="nav-item" onClick={closeMenu}>Contact Us</a>
          
          {/* Quick Info inside Mobile Nav */}
          <div className="mobile-info">
            <a href="tel:8826265224" className="mobile-info-item">
              <Icon name="phone" size={18} />
              <span>8826265224</span>
            </a>
            <a href="mailto:activejoint1@gmail.com" className="mobile-info-item">
              <Icon name="mail" size={18} />
              <span>activejoint1@gmail.com</span>
            </a>
          </div>
        </div>

        {/* Navigation Action Buttons */}
        <div className="nav-actions">
          <a 
            href="https://wa.me/918826265224?text=Hello%20Dr.%20Anil%20Kumar,%20I%20would%20like%20to%20book%20a%20physiotherapy%20consultation." 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn btn-primary nav-cta pulse-button"
          >
            <Icon name="calendar" size={18} />
            <span>Book Appointment</span>
          </a>

          {/* Hamburger Icon for Mobile */}
          <button className="mobile-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            <Icon name={isOpen ? 'x' : 'menu'} size={26} />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
